/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { getScrollPosition, getY, scrollGetY, setY } from 'utils/scrolling';
import { getSvgIcon } from '../../../resources';
import AppStyle from '../../../scss/main/App.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from 'store/types';

const BAD: React.FC<{}> = () => {

  const isIOS = navigator.maxTouchPoints > 1 || /iPad|iPhone|iPod|Mobile/.test(navigator.userAgent) || /iPad|iPhone|iPod|Mobile/.test(navigator.platform)

  const scrollY = useSelector((state: RootState) => state.ui.scrollY);

  const image1: any = useRef<HTMLInputElement>(null);
  const image1Y: number = (image1 && image1.current && image1.current.offsetTop) || 0

  if (getY('bk-image1Y') !== image1Y && image1Y !== 0) {
    setY('bk-image1Y', image1Y)
  }

  return (
    <div className={AppStyle["skill-cloud"]}>
      <div>
        <div>
          <div>
          How I Do
          </div>
        </div>
        <div>
          <div>
            <div>The architecture and applications involved in Backend are much more complex than Frontend. Including databases, APIs, and servers are almost all the necessities of web applications. In software architecture, there may be many layers between the hardware and the end-user. The front is an abstraction, simplifying the underlying component by providing a user-friendly interface, while the back usually handles data storage and business logic.</div>
            <div>At present, I mainly use MongoDB, OracleDB and SQL Server and other major databases to process and store data, and develop APIs based on Rest or GraphQL standards. Furthermore, I can still use ASP.NET Core or Ruby on Rails to cooperate with Frontend according to project needs. In web application development, I also use a technology called CDN, which is a web accelerator that can enhance the user experience.</div>
          </div>
        </div>
      </div>
      <div ref={image1}  >
        <video id={isIOS ? AppStyle['isIOS-video'] : AppStyle['isNonIOS-video']} src={process.env.REACT_APP_CDN_PATH + 'bf237d7c2a64301fe84effa8e25f00b8a5fffe8c06da4fc53e0d9663c63f2563.webm'} autoPlay={true} loop={true} style={{willChange: 'transform', transform: `translate3d(0px, ${scrollGetY(getScrollPosition(), getY(`bk-image1Y`), 1.5)}%, 0px)`}} playsInline={true} controls={false} muted={true} />
        <div id={isIOS ? AppStyle['isIOS-image'] : AppStyle['isNonIOS-image']} style={{backgroundImage: `url('${process.env.REACT_APP_CDN_PATH + 'bf237d7c2a64301fe84effa8e25f00b8a5fffe8c06da4fc53e0d9663c63f2563.webp'}')`}} />
      </div>
      <div>
        <div>
          Main<br />Technology
        </div>
        <div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'api'})}`}} />
            <div>
              API
            </div>
            <div>
              Rest standards, GraphQL, ASP.NET Core or Ruby on Rails are also one of the APIs that I often use to develop framworks. Regardless of which framwork is used, consistent performance and security standards can be achieved.
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'cloud'})}`}} />
            <div>
              Cloud
            </div>
            <div>
              Nowadays, websites generally using the cloud as a server, the biggest feature of the cloud is to provide comprehensive security protection and stability while maintaining high speed. I mainly use AWS and Azure to develop applications, but I can still use other cloud services, such as GCP and Alibaba Cloud, in accordance with the requirements of the project.
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'database'})}`}} />
            <div>
              Database
            </div>
            <div>
              I mainly use three different types of databases: MongoDB, Oracle DB, and SQL Server. Each database has its own advantages and characteristics. I will choose the right database according to the size and type of the project.
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'server'})}`}} />
            <div>
              Server
            </div>
            <div>
              Depending on the needs of the project, you may need to use a server like Ubuntu Server to debug and publish applications. These will depend on the complexity of the project. For example, when you need to use Docker to package different interfaces, you need to use Linux Server to control.
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          List of<br />Development<br />Technologies
        </div>
        <div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'aws'})}`}}  />
            <div>
              AWS
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'azure'})}`}}  />
            <div>
              Azure
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'asp'})}`}}  />
            <div>
              ASP.NET Core
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'rails'})}`}}  />
            <div>
              Ruby on Rails
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'graphql'})}`}}  />
            <div>
              GraphQL
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'spring'})}`}}  />
            <div>
              Spring
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'flask'})}`}}  />
            <div>
              Flask
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'laravel'})}`}}  />
            <div>
              Laravel
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'mongo'})}`}}  />
            <div>
              MongoDB
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'mssql'})}`}}  />
            <div>
              SQL Server
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'mysql'})}`}}  />
            <div>
              MySQL
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'redis'})}`}}  />
            <div>
              Redis
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'docker'})}`}}  />
            <div>
              Docker
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'linux'})}`}}  />
            <div>
              Linux
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className={`${AppStyle["buttonLine"]}`}>
          <Link to='/skills'>
            Show Me Others
            <div className={AppStyle["button-border"]} />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default BAD